import React from "react";
import FAQAccordion from '../FAQAccordion';

class ColoradoRiverInfo extends React.Component {
  render() {
    return (
      <React.Fragment>
        <section className="about-us pt-trip gray-light-bg">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-10">

                <p>
                  A two-day Colorado River kayaking trip from{" "}
                  <a href="https://www.nps.gov/glca/planyourvisit/leesferryarea.htm" target="_blank" rel="noopener noreferrer">
                    Lee's Ferry
                  </a>{" "}
                  near Page, Arizona is one of the most spectacular paddles in the American Southwest. You're deep inside Glen Canyon, surrounded by 800-foot sandstone walls the color of burnt orange and rust. The water is flat, cold, and impossibly clear — it comes straight out of the bottom of Lake Powell. There are no rapids, no crowds, and no noise. Just the canyon, the river, and you.
                </p>
                <p>
                  While you're in the area, you'd be doing yourself a disservice to skip{" "}
                  <strong>Antelope Canyon</strong> and{" "}
                  <strong>Horseshoe Bend</strong> — two of the most photographed landscapes in the country, both within 15 minutes of Lee's Ferry. Plan for them on Day 1 before getting on the water, or Day 2 after you're done paddling.
                </p>

                <h2>Day 1 — Arrive, Antelope Canyon & Horseshoe Bend</h2>
                <p>
                  Fly into Phoenix (PHX) or Las Vegas (LAS) — both are roughly 4–5 hours from Page, AZ. If flying into Vegas, the drive takes you through Zion and the Arizona Strip for a scenic introduction to canyon country. Arrive in Page by early afternoon.
                </p>
                <ul>
                  <li>
                    <strong>Antelope Canyon</strong> — book a guided tour in advance (required). Lower Antelope Canyon has more dramatic light beams; Upper has easier access. Tours run about 1.5 hours and cost $50–$80/person. Book through{" "}
                    <a href="https://www.navajotours.com/" target="_blank" rel="noopener noreferrer">Navajo Tours</a>{" "}
                    or Ken's Tours.
                  </li>
                  <li>
                    <strong>Horseshoe Bend</strong> — a 1.5-mile round-trip walk from the parking lot. Go at golden hour (1–2 hours before sunset) for the best light. Free to visit; $10 parking fee.
                  </li>
                  <li>Stay overnight in Page — Courtyard Marriott, Hyatt Place, or vacation rental.</li>
                </ul>

                <h2>Day 2 — On the Water at Lee's Ferry</h2>
                <p>
                  Head to Lee's Ferry at the northern edge of Grand Canyon National Park. Rent a kayak or stand-up paddleboard from{" "}
                  <a href="https://www.canyonlandstours.com/" target="_blank" rel="noopener noreferrer">Canyonlands Tours</a>{" "}
                  or Wilderness River Adventures, both located in Page (they transport gear to the put-in). The paddle from Lee's Ferry through the lower Glen Canyon section is calm and entirely flat — ideal for beginners and intermediates alike.
                </p>
                <ul>
                  <li><strong>Distance:</strong> 4–15 miles depending on how far you paddle (completely customizable)</li>
                  <li><strong>Water temperature:</strong> 48–55°F year-round — a wetsuit is highly recommended</li>
                  <li><strong>Best season:</strong> March–October (water levels are stable; avoid monsoon season July–August)</li>
                  <li><strong>Wildlife:</strong> Great blue herons, bald eagles, bighorn sheep on the canyon walls</li>
                  <li><strong>Camping option:</strong> Primitive camping is allowed along the riverbank — coordinate with your rental company for overnight permits</li>
                </ul>

                <h2>What to Pack</h2>
                <ul>
                  <li>Wetsuit or drysuit (water is cold even in summer)</li>
                  <li>Sun protection — sunscreen, hat, UV-blocking shirt (canyon sun is intense)</li>
                  <li>Dry bags for phone, camera, and valuables</li>
                  <li>Water and snacks (2L minimum per person per day)</li>
                  <li>Water shoes or sandals with heel straps</li>
                  <li>Polarized sunglasses — the reflection off the water is brutal</li>
                </ul>

                <h2>Extending the Trip</h2>
                <p>
                  Page is perfectly positioned between two world-class destinations. Heading northeast takes you to{" "}
                  <a href="/itineraries/utah-national-parks-road-trip">the Utah National Parks loop</a> — Zion, Bryce Canyon, and beyond. Heading south puts you at the South Rim of the Grand Canyon in under 3 hours. Many people combine this kayak trip with a 5–7 day Southwest road trip that hits multiple parks.
                </p>
                <p>
                  To view the full 2-day driving and paddling route, click <strong>"more options"</strong> on the Google Maps embed above.
                </p>

                <FAQAccordion
                  title="Colorado River Kayaking FAQs"
                  items={[
                    { q: "Do I need kayaking experience to kayak the Colorado River near Lee's Ferry?", a: "The stretch near Lee's Ferry is calm and flat — no prior kayaking experience is required. The current moves slowly and it is suitable for beginners." },
                    { q: 'What is the best time of year to kayak the Colorado River?', a: 'Spring (March–May) and fall (September–November) offer the most comfortable temperatures. Summer is hot but manageable with early starts. Avoid flash flood season (July–August) if possible.' },
                    { q: "Where do you launch for Colorado River kayaking near Lee's Ferry?", a: "The launch point is at Lee's Ferry in Glen Canyon National Recreation Area, about 40 miles north of Page, Arizona. The area has parking and basic facilities." },
                    { q: 'Can you see Antelope Canyon and Horseshoe Bend on the same trip?', a: 'Yes — both are near Page, AZ and are commonly combined on a 2-day itinerary. Antelope Canyon requires a guided tour (book well in advance), while Horseshoe Bend is a short walk from the parking lot.' },
                    { q: "Do I need a permit to kayak the Colorado River at Lee's Ferry?", a: "A National Park Service permit or day-use fee for Glen Canyon NRA is required. Multi-day permits for the main canyon below Lee's Ferry are competitive — apply through recreation.gov." },
                    { q: 'Is camping allowed on the Colorado River trip?', a: "Yes — riverside camping is permitted at designated sites. You'll need a fire pan, portable toilet, and Leave No Trace gear. Reservations for sites fill up months in advance." },
                    { q: 'What should I bring for a 2-day Colorado River kayak trip?', a: "Dry bags, sunscreen, wide-brim hat, river sandals, plenty of water, camping gear, and a headlamp. Water from the river is not drinkable without a filter. Pack light — you're carrying everything on your boat." },
                  ]}
                />

              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default ColoradoRiverInfo;
